export const MIN_SURPLUS_PLAYS = 1_000;
export const MAX_SURPLUS_PLAYS = 99_999_999;

export function isValidSurplusQuantity(quantity: number) {
  return Number.isSafeInteger(quantity) && quantity >= MIN_SURPLUS_PLAYS && quantity <= MAX_SURPLUS_PLAYS;
}

export function getSurplusQuote(quantity: number) {
  if (!isValidSurplusQuantity(quantity)) throw new Error('Informe uma quantidade inteira a partir de 1.000 plays.');
  const tenthsOfCent = quantity >= 1_000_000 ? 10 : quantity >= 100_000 ? 14 : 20;
  return {
    unit_amount_decimal: String(tenthsOfCent / 10),
    unitPrice: tenthsOfCent / 1000,
    total_cents: Math.round(quantity * tenthsOfCent / 10),
  };
}

export const formatSurplusCurrency = (value: number) => value.toLocaleString('pt-BR', {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
});
export const formatSurplusUnitPrice = (value: number) => value.toLocaleString('pt-BR', {
  minimumFractionDigits: 2, maximumFractionDigits: 3,
});

export function parseSurplusQuantity(value: string) {
  const trimmed = value.trim();
  if (!/^(?:\d+|\d{1,3}(?:\.\d{3})+)$/.test(trimmed)) return NaN;
  return Number(trimmed.replaceAll('.', ''));
}

export interface SurplusAttempt { id: string; quantity: number; card: string; total_cents?: number; unit_amount_decimal?: string }
export function isSurplusAttempt(value: unknown): value is SurplusAttempt {
  const attempt = value as SurplusAttempt | null;
  return typeof attempt?.id === 'string' && !!attempt.id && typeof attempt.card === 'string' && !!attempt.card &&
    isValidSurplusQuantity(attempt.quantity) && (
      (attempt.total_cents === undefined && attempt.unit_amount_decimal === undefined) ||
      ([1, 1.4, 2].includes(Number(attempt.unit_amount_decimal)) && Number.isSafeInteger(attempt.total_cents) &&
        attempt.total_cents === Math.round(attempt.quantity * (Number(attempt.unit_amount_decimal) * 10) / 10))
    );
}
